"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight, ChartBar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringSustainableGrowth() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="22513" id="trusted-practical-guidance" className="relative w-full overflow-hidden bg-primary-900 text-primary-foreground">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(53,128,121,0.18),transparent_42%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-[78vh] py-20 lg:py-24">
          <div ref={textRef} className={`transition-all duration-1000 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-default font-bold tracking-tight text-white mb-6 leading-[1.05] max-w-3xl">
              Trusted, practical guidance
              <br />
              <span className="text-secondary/90">
                for Northern organizations
                <br className="hidden md:block" />
                and First Nation communities
              </span>
            </h1>

            <p className="text-base md:text-lg text-primary-100/85 leading-relaxed max-w-xl mb-8 font-default">
              RiverBend supports governance, community development, and complex
              financial work through hands-on advisory, controllership, audit
              readiness, and practical systems built for real-world Northern
              conditions.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-12 px-8 text-base shadow-md bg-secondary-600 hover:bg-secondary-700 text-white font-default rounded-md">
                <Link to="/services">
                  Explore Services
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base border-secondary/50 text-secondary bg-transparent hover:bg-secondary/10 hover:text-secondary font-default rounded-md">
                <Link to="/about-riverbend">
                  Learn More
                  <ChartBar className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-6 bg-secondary/20 blur-3xl rounded-full pointer-events-none" />

            <div className="relative overflow-hidden rounded-2xl shadow-2xl border border-white/10 bg-primary-800">
              <div className="aspect-[4/3] lg:aspect-[5/4] overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624643/img/lake_superior_waves.png" alt="Northern lake and shoreline" className="w-full h-[115%] object-cover object-center grayscale-[5%] contrast-[1.08]" style={{
                transform: `translateY(${scrollY * 0.08}px)`,
                transition: "transform 0.1s linear"
              }} />
              </div>

              <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/35 via-transparent to-secondary/10 pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}